import React from 'react';
import {Route, Routes} from 'react-router-dom';
import {CONTENT_SUBMISSION_ROUTES} from '@/routes/content-submissions/contentSubmissionRouteDefinitions';
import {ROUTES} from '@/config/routesConstants';
import BriefViewer from '@/views/campaigns/brief-viewer/BriefViewer';
import CampaignV2 from '@/views/campaigns/campaign-v2';
import CampaignsList from '@/views/campaigns/campaigns-list';
import ContentSubmissionView from '@/views/campaigns/content-submissions/ContentSubmissionView';
import ContentSubmissionsTab from '@/views/campaigns/content-submissions/ContentSubmissionsTab';
import MixedMediaView from '@/views/campaigns/content-submissions/MixedMediaView';
import CampaignCreatorsTab from '@/views/campaigns/creators-tab';
import CampaignStatisticsTab from '@/views/campaigns/statistics-tab/CampaignStatisticsTab';
import Profile from '@/views/creators/profile/Profile';
import SpinningLoader from '@/components/spinning-loader';

const CAMPAIGNS_V2_ROUTES = {
  MAIN: '',
  CAMPAIGN: ':campaignId',
  CREATORS: 'creators',
  CREATOR_PROFILE: `creators${ROUTES.CREATOR_PROFILE}/:creatorId`,
  ASSETS: 'assets',
  STATISTICS: 'statistics',
  BRIEF: 'brief',
};

function CampaignsV2Routes() {
  return (
    <Routes>
      <Route path={CAMPAIGNS_V2_ROUTES.MAIN} element={<CampaignsList />} />
      <Route path={CAMPAIGNS_V2_ROUTES.CAMPAIGN} element={<CampaignV2 />}>
        <Route
          path={CAMPAIGNS_V2_ROUTES.CREATORS}
          element={<CampaignCreatorsTab />}
        />
        <Route
          path={CAMPAIGNS_V2_ROUTES.ASSETS}
          element={<ContentSubmissionsTab />}
        />
        <Route
          path={CAMPAIGNS_V2_ROUTES.STATISTICS}
          element={<CampaignStatisticsTab />}
        />
      </Route>
      {/* These routes render outside CampaignV2 layout (no tabs) */}
      <Route
        path={`${CAMPAIGNS_V2_ROUTES.CAMPAIGN}/${CAMPAIGNS_V2_ROUTES.BRIEF}`}
        element={<BriefViewer />}
      />
      <Route
        path={`${CAMPAIGNS_V2_ROUTES.CAMPAIGN}/${CAMPAIGNS_V2_ROUTES.CREATOR_PROFILE}`}
        element={
          <Profile
            customLoader={
              <SpinningLoader color="black" containerHeight="100%" />
            }
          />
        }
      />
      <Route
        path={`${CAMPAIGNS_V2_ROUTES.CAMPAIGN}/${CAMPAIGNS_V2_ROUTES.ASSETS}/${CONTENT_SUBMISSION_ROUTES.parentContentSubmission}`}
        element={<MixedMediaView />}
      />
      <Route
        path={`${CAMPAIGNS_V2_ROUTES.CAMPAIGN}/${CAMPAIGNS_V2_ROUTES.ASSETS}/${CONTENT_SUBMISSION_ROUTES.mixedMediaContentSubmission}`}
        element={<ContentSubmissionView />}
      />
      <Route
        path={`${CAMPAIGNS_V2_ROUTES.CAMPAIGN}/${CAMPAIGNS_V2_ROUTES.ASSETS}/${CONTENT_SUBMISSION_ROUTES.contentSubmission}`}
        element={<ContentSubmissionView />}
      />
    </Routes>
  );
}

export default CampaignsV2Routes;
